import { computed } from 'vue'
import { useRoute } from 'vue-router'

/**
 * Composable for handling URL parameters
 * Provides access to common URL parameters with appropriate defaults
 */
export function useUrlParams() {
  const route = useRoute()

  // Get countryCode from URL or default to 'tw'
  const countryCode = computed(() =>
    route.query.countryCode?.toString() || 'tw'
  )

  // Get placeId from URL or default to null
  const placeId = computed(() =>
    route.query.placeId?.toString() || null
  )

  /**
   * Helper function to get URL parameters for navigation
   * @param additionalParams Additional query parameters to include
   * @returns Object with all query parameters
   */
  const getQueryParams = (additionalParams: Record<string, string> = {}) => {
    const params: Record<string, string> = {
      ...additionalParams
    }

    // Always include countryCode if available
    if (countryCode.value) {
      params.countryCode = countryCode.value
    }

    // Always include placeId if available in additionalParams or in the URL
    if (!params.placeId && placeId.value) {
      params.placeId = placeId.value
    }

    return params
  }

  return {
    countryCode,
    placeId,
    getQueryParams
  }
}
